import { pdfjs, Document, Page } from 'react-pdf'
import './Resume.css'
// import "react-pdf/dist/esm/Page/TextLayer.css";
import 'react-pdf/dist/Page/TextLayer.css';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import download from '../../images/download.png'

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const options = {
cMapUrl: `https://unpkg.com/pdfjs-dist@${pdfjs.version}/cmaps/`,
};

export const Resume = () => {
    
    return (
    <div className='resumeWrapper'>
        <div className='downloadLink'>
            <a href="/Alirie_Gray_Resume.pdf" download>
                <img src={download} width='50px'></img>
            </a>
        </div>
        <Document options={options} file={{
            url: "https://www.aliriegray.com/Alirie_Gray_Resume.pdf"
        }} >
            <Page pageNumber={1} />
        </Document>
    </div>
)}